import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&family=VT323&display=swap');
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }
  
  body {
    font-family: ${theme.fonts.secondary};
    background-color: ${theme.colors.background};
    color: ${theme.colors.text};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.primary};
    margin-bottom: 1rem;
    line-height: 1.2;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  
  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    transition: ${theme.transitions.default};
    
    &:hover {
      color: ${theme.colors.accent};
    }
  }
  
  button {
    font-family: ${theme.fonts.primary};
    cursor: pointer;
    border: none;
    outline: none;
    transition: ${theme.transitions.default};
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
  
  // CRT TV effect for the main container
  .crt-effect {
    position: relative;
    overflow: hidden;
    
    &::before {
      ${theme.scanlines.before}
    }
    
    &::after {
      ${theme.scanlines.after}
    }
  }
  
  // Glitch effect for text (optional)
  .glitch {
    position: relative;
    
    &::before, &::after {
      content: attr(data-text);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    
    &::before {
      left: 2px;
      text-shadow: -2px 0 #ff00c1;
      clip: rect(44px, 450px, 56px, 0);
      animation: glitch-anim 5s infinite linear alternate-reverse;
    }
    
    &::after {
      left: -2px;
      text-shadow: -2px 0 #00fff9, 2px 2px #ff00c1;
      clip: rect(44px, 450px, 56px, 0);
      animation: glitch-anim2 5s infinite linear alternate-reverse;
    }
  }
  
  @keyframes glitch-anim {
    0% { clip: rect(31px, 9999px, 94px, 0); }
    10% { clip: rect(112px, 9999px, 76px, 0); }
    20% { clip: rect(85px, 9999px, 77px, 0); }
    30% { clip: rect(27px, 9999px, 97px, 0); }
    40% { clip: rect(64px, 9999px, 98px, 0); }
    50% { clip: rect(67px, 9999px, 62px, 0); }
    60% { clip: rect(83px, 9999px, 39px, 0); }
    70% { clip: rect(40px, 9999px, 73px, 0); }
    80% { clip: rect(61px, 9999px, 85px, 0); }
    90% { clip: rect(66px, 9999px, 103px, 0); }
    100% { clip: rect(62px, 9999px, 102px, 0); }
  }
  
  @keyframes glitch-anim2 {
    0% { clip: rect(65px, 9999px, 119px, 0); }
    10% { clip: rect(33px, 9999px, 69px, 0); }
    20% { clip: rect(34px, 9999px, 12px, 0); }
    30% { clip: rect(86px, 9999px, 82px, 0); }
    40% { clip: rect(91px, 9999px, 91px, 0); }
    50% { clip: rect(30px, 9999px, 52px, 0); }
    60% { clip: rect(98px, 9999px, 85px, 0); }
    70% { clip: rect(94px, 9999px, 68px, 0); }
    80% { clip: rect(31px, 9999px, 16px, 0); }
    90% { clip: rect(18px, 9999px, 40px, 0); }
    100% { clip: rect(73px, 9999px, 67px, 0); }
  }
  
  // Scanlines animation
  @keyframes scanline {
    0% {
      transform: translate3d(0, 0, 0);
      opacity: 0.3;
    }
    100% {
      transform: translate3d(0, 100%, 0);
      opacity: 0;
    }
  }
  
  // Flicker animation for the TV effect
  @keyframes flicker {
    0% { opacity: 0.9; }
    5% { opacity: 0.8; }
    10% { opacity: 0.9; }
    15% { opacity: 0.85; }
    20% { opacity: 0.95; }
    25% { opacity: 0.88; }
    30% { opacity: 0.92; }
    35% { opacity: 0.87; }
    40% { opacity: 0.98; }
    45% { opacity: 0.9; }
    50% { opacity: 0.95; }
    55% { opacity: 0.92; }
    60% { opacity: 0.97; }
    65% { opacity: 0.93; }
    70% { opacity: 0.99; }
    75% { opacity: 0.94; }
    80% { opacity: 0.96; }
    85% { opacity: 0.97; }
    90% { opacity: 0.98; }
    95% { opacity: 0.99; }
    100% { opacity: 1; }
  }
`;
